import { defineStore } from 'pinia'
import { store } from '../index'

interface AppState {
  pageLoading: boolean
  title: string
  pageTopAd: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => {
    return {
      title: import.meta.env.VITE_APP_TITLE, // 标题
      pageLoading: false, // 路由跳转loading
      pageTopAd: false, // 头部广告是否展示
    }
  },
  getters: {
    getTitle(): string {
      return this.title
    },
    getPageLoading(): boolean {
      return this.pageLoading
    },
    getPageTopAd(): boolean {
      return this.pageTopAd
    },
  },
  actions: {
    setPageLoading(pageLoading: boolean) {
      this.pageLoading = pageLoading
    },
    setPageTopAd(b: boolean) {
      this.pageTopAd = b
    },
    setTitle(title: string) {
      this.title = title
    },
  },
  persist: false,
})

export const useAppStoreWithOut = () => {
  return useAppStore(store)
}
